var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 17.8,
    cy: 17.8,
    r: 16.8,
    stroke: "#DBDED4",
    strokeWidth: 0.843243
  }), /*#__PURE__*/React.createElement("g", {
    id: "email [#1573]"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2857 25C9.57563 25 9 24.4244 9 23.7143V12.2857C9 11.5756 9.57563 11 10.2857 11H25.7143C26.4244 11 27 11.5756 27 12.2857V23.7143C27 24.4244 26.4244 25 25.7143 25H10.2857ZM25.2 13.1383L18 19.6968L10.8 13.1289V12.8667H25.2V13.1383ZM10.8 23.1333V15.6153L18 22.1813L25.2 15.6228V23.1333H10.8Z",
    fill: "#8CAEB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19.6968L17.8315 19.8815L17.9999 20.0351L18.1684 19.8816L18 19.6968ZM25.2 13.1383L25.3684 13.3231L25.45 13.2487V13.1383H25.2ZM10.8 13.1289H10.55V13.2393L10.6315 13.3136L10.8 13.1289ZM10.8 12.8667V12.6167H10.55V12.8667H10.8ZM25.2 12.8667H25.45V12.6167H25.2V12.8667ZM10.8 15.6153L10.9685 15.4306L10.55 15.049V15.6153H10.8ZM10.8 23.1333H10.55V23.3833H10.8V23.1333ZM18 22.1813L17.8315 22.3661L17.9999 22.5196L18.1684 22.3662L18 22.1813ZM25.2 15.6228H25.45V15.0569L25.0316 15.438L25.2 15.6228ZM25.2 23.1333V23.3833H25.45V23.1333H25.2ZM8.75 23.7143C8.75 24.5624 9.43756 25.25 10.2857 25.25V24.75C9.71371 24.75 9.25 24.2863 9.25 23.7143H8.75ZM8.75 12.2857V23.7143H9.25V12.2857H8.75ZM10.2857 10.75C9.43756 10.75 8.75 11.4376 8.75 12.2857H9.25C9.25 11.7137 9.71371 11.25 10.2857 11.25V10.75ZM25.7143 10.75H10.2857V11.25H25.7143V10.75ZM27.25 12.2857C27.25 11.4376 26.5624 10.75 25.7143 10.75V11.25C26.2863 11.25 26.75 11.7137 26.75 12.2857H27.25ZM27.25 23.7143V12.2857H26.75V23.7143H27.25ZM25.7143 25.25C26.5624 25.25 27.25 24.5624 27.25 23.7143H26.75C26.75 24.2863 26.2863 24.75 25.7143 24.75V25.25ZM10.2857 25.25H25.7143V24.75H10.2857V25.25ZM18.1684 19.8816L25.3684 13.3231L25.0316 12.9534L17.8316 19.512L18.1684 19.8816ZM10.6315 13.3136L17.8315 19.8815L18.1685 19.5121L10.9685 12.9442L10.6315 13.3136ZM10.55 12.8667V13.1289H11.05V12.8667H10.55ZM25.2 12.6167H10.8V13.1167H25.2V12.6167ZM25.45 13.1383V12.8667H24.95V13.1383H25.45ZM10.55 15.6153V23.1333H11.05V15.6153H10.55ZM18.1685 21.9966L10.9685 15.4306L10.6315 15.8001L17.8315 22.3661L18.1685 21.9966ZM25.0316 15.438L17.8316 21.9965L18.1684 22.3662L25.3684 15.8076L25.0316 15.438ZM25.45 23.1333V15.6228H24.95V23.1333H25.45ZM10.8 23.3833H25.2V22.8833H10.8V23.3833Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundEmail);
export default __webpack_public_path__ + "static/media/round-email.79017b9f799dae2afb6077e6f86793d1.svg";
export { ForwardRef as ReactComponent };